import React, { useState, useEffect } from "react";
import Share from "./Share";

// 1. CONFIGURATION
const API_URL =
  "https://rapi.ifood.tv/blogs.php?searchType=blogs&appId=9&siteId=236&deviceId=&auth-token=1217575&version=6.0";

function BlogTiles() {
  const [listData, setListData] = useState([]);

  const getUseDashboardAPI = () => {
    return true;
    const params = new URLSearchParams(window.location.search);
    return params.get("useDashboardAPI") === "true";
  };

  useEffect(() => {
    const fetchData = async () => {
      const useDashboardAPI = getUseDashboardAPI();

      try {
        // A. Local JSON
        const jsonPromise = fetch(`./assets/data/blogs.json?r=${Date.now()}`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }).then((res) => res.json());

        // B. API (Conditional)
        let apiPromise = Promise.resolve([]);

        if (useDashboardAPI) {
          apiPromise = fetch(API_URL)
            .then((res) => res.json())
            .then((apiRes) => {
              if (
                apiRes &&
                apiRes.status === "ok" &&
                Array.isArray(apiRes.results)
              ) {
                return apiRes.results;
              }
              return [];
            })
            .catch((err) => {
              console.error("API Fetch Error:", err);
              return [];
            });
        }

        // C. Merge
        const [jsonRes, apiArr] = await Promise.all([jsonPromise, apiPromise]);
        const mergedData = [...apiArr, ...jsonRes];

        setListData(mergedData);
      } catch (err) {
        console.error("Error fetching blog tiles:", err);
      }
    };

    fetchData();
  }, []);

  return (
    <React.Fragment>
      {listData && listData.length > 0 ? getTiles(listData) : ""}
    </React.Fragment>
  );
}

// ---------------------------------------------------------
// HELPER FUNCTIONS
// ---------------------------------------------------------

// 1. QUERY PARAMETER HELPER
const appendAllQS = (href) => {
  const currentParams = new URLSearchParams(window.location.search);

  // If no params, just return the original href
  if (![...currentParams].length) return href;

  // Create a new URL object based on the current origin
  const newUrl = new URL(href, window.location.origin);

  // Append every existing param
  currentParams.forEach((value, key) => {
    newUrl.searchParams.set(key, value);
  });

  return newUrl.toString();
};

// 2. Link Generator (For Individual Articles)
const getPostLink = (item) => {
  // CASE A: API Data (Has slug)
  if (item.blog_url) {
    const basePath = `./blogs/${item.id}/${item.blog_url}`;
    // Use the helper to attach ?useDashboardAPI=true (and anything else)
    return appendAllQS(basePath);
  }

  // CASE B: Local Data (No slug)
  return `./blogs/${item.id}`;
};

// 3. Styling Helpers
const stripHtml = (html) => {
  if (!html) return "";
  return html.replace(/<[^>]*>?/gm, "");
};

const renderDate = (item) => {
  let dateStr = "";
  if (item.date) {
    dateStr = item.date;
  } else if (item.date_published) {
    const dateObj = new Date(item.date_published);
    dateStr = dateObj.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }
  return <span className="date">{dateStr}</span>;
};

const renderReadingTime = (item) => {
  const rt = item.reading_time;
  if (!rt) return null;
  const str = String(rt);
  if (str.includes("<")) {
    return (
      <div
        style={{ marginTop: "2px" }}
        dangerouslySetInnerHTML={{ __html: str }}
      />
    );
  }
  return (
    <div style={{ marginTop: "2px" }}>
      <p className="read-time" style={{ margin: 0 }}>
        Reading Time: {str} min
      </p>
    </div>
  );
};

const truncateStyle = {
  display: "-webkit-box",
  WebkitLineClamp: "3",
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  marginBottom: "10px",
  minHeight: "4.5em",
};

// ---------------------------------------------------------
// MAIN RENDER FUNCTION
// ---------------------------------------------------------

const getTiles = (items) => {
  return (
    <section id="watchblogtiles" className="padVerTab">
      {/* 1. WEB VIEW */}
      <div className="container-fluid row col-md-12 d-flex justify-content-center web-view">
        <div className="row text-center">
          {/* LINK UPDATED: Header */}
          <a
            href={appendAllQS("./blogs")}
            rel=""
            className="blog-link gtm-lp gtm-blog-link"
          >
            <h1>Blogs</h1>
          </a>

          <span className="my-2 px-4">
            {/* LINK UPDATED: Subtext */}
            <a
              href={appendAllQS("./blogs")}
              rel=""
              className="blog-link gtm-lp gtm-blog-link"
            >
              Stay Up To Date With Trending Movies and More
            </a>
          </span>
        </div>
        {items.slice(0, 3).map((item, index) => (
          <article className="blog-tiles col-md-3" key={index}>
            <div className="blog-tiles-container">
              <div className="blog-tiles-image col-md-12 col-sm-12">
                <img src={item.image} alt={item.alt_text} />
              </div>
              <div className="blog-tiles-content col-md-12 col-sm-12">
                <div className="blog-tiles-meta">
                  <img src="./assets/images/ico-calendar.png" alt=""></img>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  {renderDate(item)}
                </div>
                <hr />
                <div className="blog-tiles-header">
                  <h2
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: "2",
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {stripHtml(item.title)}
                  </h2>
                </div>

                <div
                  dangerouslySetInnerHTML={{
                    __html: stripHtml(item.short_description),
                  }}
                  style={truncateStyle}
                />

                <div className="d-flex justify-content-start flex-wrap">
                  <p>
                    <img
                      style={{ width: "1.5em", marginBottom: "0em" }}
                      src="./assets/images/ico-timer.svg"
                      alt=""
                    ></img>
                  </p>
                  &nbsp;&nbsp;
                  {renderReadingTime(item)}
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-md-6 p-0">
                      <a
                        href={getPostLink(item)}
                        className="btn btn-primary read-more-btn gtm-lp gtm-blog-read-more"
                      >
                        READ MORE
                      </a>
                    </div>
                    <div className="col-12 col-md-6 p-0 text-end share-container">
                      <Share
                        url={getPostLink(item)}
                        msg={"Watch%20Now%20On%20Fawesome"}
                      ></Share>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        ))}
        <div className="text-center show-all">
          {/* LINK UPDATED: Footer Link */}
          <a
            href={appendAllQS("./blogs")}
            rel=""
            className="blog-link gtm-lp gtm-blog-link"
          >
            <p>Go To Blogs &raquo;</p>
          </a>
        </div>
      </div>

      {/* 2. TAB VIEW */}
      <div className="container-fluid row col-12 d-flex justify-content-center tab-view d-none">
        <div className="row text-center">
          {/* LINK UPDATED */}
          <a
            href={appendAllQS("./blogs")}
            rel=""
            className="blog-link gtm-lp gtm-blog-link"
          >
            <h1>Blogs</h1>
          </a>
          <span className="my-2 px-4">
            {/* LINK UPDATED */}
            <a
              href={appendAllQS("./blogs")}
              rel=""
              className="blog-link gtm-lp gtm-blog-link"
            >
              Stay Up To Date With Trending Movies and More
            </a>
          </span>
        </div>
        {items.slice(0, 2).map((item, index) => (
          <article className="blog-tiles col-5" key={index}>
            <div className="blog-tiles-container">
              <div className="blog-tiles-image col-md-12 col-sm-12">
                <img src={item.image} alt={item.alt_text} />
              </div>
              <div className="blog-tiles-content col-md-12 col-sm-12">
                <div className="blog-tiles-meta">
                  <img src="./assets/images/ico-calendar.png" alt=""></img>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  {renderDate(item)}
                </div>
                <hr />
                <div className="blog-tiles-header">
                  <h2
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: "2",
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {stripHtml(item.title)}
                  </h2>
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: stripHtml(item.short_description),
                  }}
                  style={truncateStyle}
                />
                <div className="d-flex justify-content-start flex-wrap">
                  <p>
                    <img
                      style={{ width: "1.5em", marginBottom: "0em" }}
                      src="./assets/images/ico-timer.svg"
                      alt=""
                    ></img>
                  </p>
                  &nbsp;&nbsp;
                  {renderReadingTime(item)}
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-md-6 p-0">
                      <a
                        href={getPostLink(item)}
                        className="btn btn-primary read-more-btn gtm-lp gtm-blog-read-more"
                      >
                        READ MORE
                      </a>
                    </div>
                    <div className="col-12 col-md-6 p-0 text-end share-container">
                      <Share
                        url={getPostLink(item)}
                        msg={"Watch%20Now%20On%20Fawesome"}
                      ></Share>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        ))}
        <div className="text-center show-all">
          {/* LINK UPDATED */}
          <a
            href={appendAllQS("./blogs")}
            rel=""
            className="blog-link gtm-lp gtm-blog-link"
          >
            <p>Go To Blogs &raquo;</p>
          </a>
        </div>
      </div>

      {/* 3. MOBILE VIEW */}
      <div className="container-fluid d-flex justify-content-center mobile-view d-none">
        <div className="text-center px-5">
          {/* LINK UPDATED */}
          <a
            href={appendAllQS("./blogs")}
            rel=""
            className="blog-link gtm-lp gtm-blog-link"
          >
            <h1>Blogs</h1>
          </a>
          <span className="my-2">
            {/* LINK UPDATED */}
            <a
              href={appendAllQS("./blogs")}
              rel=""
              className="blog-link gtm-lp gtm-blog-link"
            >
              <span>Stay Up To Date With Trending Movies and More</span>
            </a>
          </span>
        </div>
        {items.slice(0, 1).map((item, index) => (
          <article className="blog-tiles col" key={index}>
            <div className="blog-tiles-container">
              <div className="blog-tiles-image col-md-12 col-sm-12">
                <img src={item.image} alt={item.alt_text} />
              </div>
              <div className="blog-tiles-content col-md-12 col-sm-12">
                <div className="blog-tiles-meta">
                  <img src="./assets/images/ico-calendar.png" alt=""></img>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  {renderDate(item)}
                </div>
                <hr />
                <div className="blog-tiles-header">
                  <h2>{stripHtml(item.title)}</h2>
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: stripHtml(item.short_description),
                  }}
                  style={truncateStyle}
                />
                <div className="d-flex justify-content-start flex-wrap">
                  <p>
                    <img
                      style={{ width: "1.5em", marginBottom: "0em" }}
                      src="./assets/images/ico-timer.svg"
                      alt=""
                    ></img>
                  </p>
                  &nbsp;&nbsp;
                  {renderReadingTime(item)}
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-12 p-0 text-center pb-3">
                      <a
                        href={getPostLink(item)}
                        className="btn btn-primary read-more-btn gtm-lp gtm-blog-read-more "
                      >
                        READ MORE
                      </a>
                    </div>
                    <div className="col-12 p-0 text-center share-container">
                      <Share
                        url={getPostLink(item)}
                        msg={"Watch%20Now%20On%20Fawesome"}
                      ></Share>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        ))}
        <div className="text-center show-all">
          {/* LINK UPDATED */}
          <a
            href={appendAllQS("./blogs")}
            rel=""
            className="blog-link gtm-lp gtm-blog-link"
          >
            <p>Go To Blogs &raquo;</p>
          </a>
        </div>
      </div>
    </section>
  );
};

export default BlogTiles;
